
















































































































import { Component, Prop, Vue } from 'vue-property-decorator'
import DatePicker from './DatePickers.vue'
import { State } from 'vuex-class'
import dayjs, { Dayjs } from 'dayjs'
import { BookingDetail, RoomItemDetail } from '../api/hex-interface'
import tInput from './Input'
import { postBookingRoom } from '../api/hex'

enum flag {
  Order,
  Ordering,
  Failed,
  Success
}

@Component({
  components: {
    DatePicker,
    tInput
  }
})
export default class BookingDialog extends Vue {
  private flag = flag
  private state = flag.Order
  private datePickerIsShow = false
  private datePickerTarget = 'from'
  private selected: Set<string> = new Set()
  private name = ''
  private nameHasError = false
  private phone = ''
  private phoneHasError = false
  private from = ''
  private to = ''

  public dateHasError = false

  @State('bookingDetail') bookingDetail!: BookingDetail[]
  @State('roomDetail') roomDetail!: RoomItemDetail

  get title () {
    switch (this.state) {
      case flag.Order:
        return '預約時段'
      case flag.Ordering:
        return '預約中'
      case flag.Failed:
        return '預約失敗'
      case flag.Success:
        return '預約成功'
    }
  }
  getHoliday () {
    return [...this.selected].reduce((prev, curr) => (prev += dayjs(curr).get('day') % 6 === 0 ? 1 : 0), 0)
  }
  getNoramlDay () {
    return [...this.selected].reduce((prev, curr) => (prev += dayjs(curr).day() % 6 === 0 ? 0 : 1), 0)
  }

  getCountingPrice () {
    return this.getHoliday() * this.roomDetail.holidayPrice + this.getNoramlDay() * this.roomDetail.normalDayPrice
  }

  get disabledDate () {
    return this.bookingDetail.map(ele => ele.date)
  }

  get confirmIsDisabled () {
    return (this.nameHasError || this.phoneHasError || this.dateHasError)
  }
  fromOnFocus () {
    this.datePickerTarget = 'from'
    this.datePickerIsShow = true
  }
  toOnFocus () {
    this.datePickerTarget = 'to'
    this.datePickerIsShow = true
  }
  fillSelect () {
    if (!this.selected.has(this.from)) this.selected.add(this.from)
    if (!this.selected.has(this.to)) this.selected.add(this.to)
    let from = dayjs(this.from)
    let to = dayjs(this.to)
    let tmp: Dayjs = from.clone()
    while (!tmp.add(1, 'day').isSame(to)) {
      this.selected.add(tmp.add(1, 'day').format('YYYY-MM-DD'))
      tmp = tmp.add(1, 'day')
    }
  }
  onAdd (value: string) {
    if (this.datePickerTarget === 'from') {
      if (!this.to) {
        this.from = value
        this.to = value
      } else if (this.to && dayjs(this.to).isAfter(value)) {
        this.from = value
        this.fillSelect()
      } else {
        alert('input incorrect')
      }
      this.selected.add(value)
    } else {
      if (!this.from) {
        this.to = value
      } else if (this.from && dayjs(this.from).isBefore(value)) {
        this.to = value
        this.fillSelect()
      } else {
        alert('Input incorrect')
      }
    }
    this.datePickerIsShow = false
    this.dateValidate()
    this.$forceUpdate()
  }
  onRemove (value: string) {
    if (this.datePickerTarget === 'from') {
      this.from = ''
      this.selected.clear()
      this.to !== '' && this.selected.add(this.to)
    } else {
      this.to = value
      this.selected.delete(value)
      this.selected.clear()
      this.from !== '' && this.selected.add(this.from)
    }
    this.datePickerIsShow = false
    this.$forceUpdate()
  }

  nameValidate (value: string) {
    this.nameHasError = value === ''
  }

  phoneValidate (value: string) {
    this.phoneHasError = value === ''
  }

  dateValidate () {
    this.dateHasError = this.from === '' || this.to === ''
  }

  validate () {
    this.nameValidate(this.name)
    this.phoneValidate(this.phone)
    this.dateValidate()
    if (!(this.nameHasError || this.phoneHasError || this.dateHasError)) {
      return true
    }
    return false
  }

  async runSubmit () {
    this.state = flag.Ordering
    let data = await postBookingRoom({
      name: this.name,
      tel: this.phone,
      date: [...this.selected]
    }, this.roomDetail.id)
    if (data instanceof Error) {
      console.error(data.message)
      this.state = flag.Failed
    } else if (!data.success) {
      this.state = flag.Failed
    } else {
      this.state = flag.Success
    }
  }

  async onCancel () {
    this.$emit('close')
  }
  onConfirm () {
    if (this.validate()) {
      this.runSubmit()
    }
  }
}
